import { NivalizInboundTransactionTimerPickUpPendingWaitingDaysStackedBarChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { PudoTransactionTimerWaitingDaysStackedBarCard } from '../../pudo/pudo-transaction-timer-waiting-days-stacked-bar-card.component';

export interface NivalizCoffinsAwaitingPickUpProps {
    accountId: string;
    navigateUrl?: string;
}

export const NivalizCoffinsAwaitingPickUp = ({ accountId, navigateUrl }: NivalizCoffinsAwaitingPickUpProps) => (
    <PudoTransactionTimerWaitingDaysStackedBarCard
        accountId={accountId}
        navigateUrl={navigateUrl}
        title={
            <FormattedMessage
                id='platform.statistics.nivaliz.coffins-awaiting-pick-up.title'
                description='Title of the Nivaliz dashboard stacked bar showing coffins awaiting pick-up grouped by waiting time'
                defaultMessage='Coffins: Awaiting pick-up'
            />
        }
        Chart={NivalizInboundTransactionTimerPickUpPendingWaitingDaysStackedBarChart}
    />
);
